import AdSlice from '../components/slices/ad-slice';
import ImageSlice from '../components/slices/image-slice';
import PropTypes from 'prop-types';
import QuoteSlice from '../components/slices/quote-slice';
import React from 'react';
import TextSlice from '../components/slices/text-slice';
import HtmlSlice from '../components/slices/html-slice';

const RenderSlices = ({ allSlices }) => (
    <>
        {allSlices.map(slice => {
            switch (slice.slice_type) {
                case 'text':
                    return <TextSlice slice={slice} key={slice.id} />;
                case 'image':
                    return <ImageSlice slice={slice} key={slice.id} />;
                case 'quote':
                    return <QuoteSlice slice={slice} key={slice.id} />;
                case 'html':
                    return <HtmlSlice slice={slice} key={slice.id} />;
                case 'ad':
                    return <AdSlice slice={slice} key={slice.id} />;
                default:
                    return '';
            }
        })}
    </>
);

RenderSlices.propTypes = {
    allSlices: PropTypes.array.isRequired,
};

export default RenderSlices;
